import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _NOTIFICATION_TYPE_DE;

import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { FilePdfOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Badge, Image, List, message, Space, Spin, Tooltip } from 'antd';
import { NotificationType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getMediaStore } from 'core/modules/media/media.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { TaskDocumentType } from 'core/modules/tasks/task.interface';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { getUserStore } from 'core/modules/users/user.store';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DateFromNow } from 'src/components/DateFromNow';
import { classes } from 'src/utils/classes';
import { setRouterQuery } from 'src/utils/router';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NotificationItem = function NotificationItem(_ref) {
  var notification = _ref.notification;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();

  var _getMediaStore = getMediaStore(),
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  var _getUserStore = getUserStore(),
      getUserById = _getUserStore.getUserById;

  var _getNotificationStore = getNotificationStore(),
      setActiveNotification = _getNotificationStore.setActiveNotification,
      isLoadingKey = _getNotificationStore.isLoadingKey;

  var _getTaskStore = getTaskStore(),
      getTaskById = _getTaskStore.getTaskById;

  var author = getUserById(notification.author);
  var Details = useMemo(function () {
    return NOTIFICATION_TYPE_DETAILS_MAP[notification.content.type];
  }, [notification]);
  var isLoading = isLoadingKey(notification.id);
  var task = getTaskById(notification.content.task);

  function onClick() {
    return _onClick.apply(this, arguments);
  }

  function _onClick() {
    _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return setActiveNotification(notification.id);

            case 3:
              setRouterQuery(router, 'taskId', notification.content.task);
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _onClick.apply(this, arguments);
  }

  return /*#__PURE__*/_jsxs(Container, {
    className: classes({
      "new": !notification.isSeen,
      unread: !notification.isRead,
      loading: isLoading
    }),
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("div", {
      className: "avatar",
      children: author && /*#__PURE__*/_jsx(Tooltip, {
        title: author.name,
        children: /*#__PURE__*/_jsx(Avatar, {
          size: "small",
          src: getUserMediaSrc(author.id),
          icon: /*#__PURE__*/_jsx(UserOutlined, {})
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsx(Badge, {
        dot: !notification.isRead,
        offset: [-4, -1],
        children: /*#__PURE__*/_jsx("span", {
          className: "title",
          children: /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "notifications.".concat(notification.content.type, ".title"),
            values: {
              task: task === null || task === void 0 ? void 0 : task.title
            },
            children: ["1", /*#__PURE__*/_jsx("em", {
              children: "2"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "details",
        children: /*#__PURE__*/_jsx(Details, {
          notification: notification
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "meta",
        children: /*#__PURE__*/_jsxs(Space, {
          split: "\u2022",
          children: [/*#__PURE__*/_jsx(DateFromNow, {
            date: notification.createdAt
          }), notification.readAt && /*#__PURE__*/_jsxs("span", {
            children: [t('notifications.read'), " ", /*#__PURE__*/_jsx(DateFromNow, {
              date: notification.readAt
            })]
          })]
        })
      })]
    }), isLoading && /*#__PURE__*/_jsx(Spin, {})]
  });
}; // Details for each type

var TaskAssignedDetails = function TaskAssignedDetails(_ref2) {
  var _notification$content;

  var notification = _ref2.notification;

  var _getUserStore2 = getUserStore(),
      getUserById = _getUserStore2.getUserById;

  var author = getUserById(notification.author);
  return /*#__PURE__*/_jsxs(Trans, {
    i18nKey: "notifications.".concat(NotificationType.TaskAssigned, ".details"),
    values: {
      author: author === null || author === void 0 ? void 0 : author.name,
      task: ((_notification$content = notification.content.reference) !== null && _notification$content !== void 0 ? _notification$content : '?').substring(0, 50)
    },
    children: ["1", /*#__PURE__*/_jsx("em", {
      children: "2"
    }), /*#__PURE__*/_jsx("em", {
      className: "task-name",
      children: "3"
    })]
  });
};

var TaskReviewerAssignedDetails = function TaskReviewerAssignedDetails(_ref3) {
  var _notification$content2;

  var notification = _ref3.notification;

  var _getUserStore3 = getUserStore(),
      getUserById = _getUserStore3.getUserById;

  var author = getUserById(notification.author);
  return /*#__PURE__*/_jsxs(Trans, {
    i18nKey: "notifications.".concat(NotificationType.TaskReviewAssigned, ".details"),
    values: {
      author: author === null || author === void 0 ? void 0 : author.name,
      task: ((_notification$content2 = notification.content.reference) !== null && _notification$content2 !== void 0 ? _notification$content2 : '?').substring(0, 50)
    },
    children: ["1", /*#__PURE__*/_jsx("em", {
      children: "1"
    }), /*#__PURE__*/_jsx("em", {
      className: "task-name",
      children: "2"
    })]
  });
};

var TaskDocumentAddedDetails = function TaskDocumentAddedDetails(_ref4) {
  var _notification$content3;

  var notification = _ref4.notification;

  var _getUserStore4 = getUserStore(),
      getUserById = _getUserStore4.getUserById;

  var _getTaskStore2 = getTaskStore(),
      getTaskById = _getTaskStore2.getTaskById;

  var _getMediaStore2 = getMediaStore(),
      getTaskDocumentMediaSrc = _getMediaStore2.getTaskDocumentMediaSrc,
      fetchTaskDocument = _getMediaStore2.fetchTaskDocument;

  var author = getUserById(notification.author);
  var task = getTaskById(notification.content.task);
  var document = useMemo(function () {
    if (!task) {
      return;
    }

    var documentId = notification.content.document;
    return task.documents.find(function (document) {
      return document.id === documentId;
    });
  }, [notification]);
  useEffect(function () {
    if (task && document) {
      fetchTaskDocument(task, document.id);
    }
  }, [task, document]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Trans, {
      i18nKey: "notifications.".concat(NotificationType.TaskDocumentAdded, ".details"),
      values: {
        author: author === null || author === void 0 ? void 0 : author.name,
        task: ((_notification$content3 = notification.content.reference) !== null && _notification$content3 !== void 0 ? _notification$content3 : '?').substring(0, 50)
      },
      children: ["1", /*#__PURE__*/_jsx("em", {
        children: "1"
      }), /*#__PURE__*/_jsx("em", {
        className: "task-name",
        children: "2"
      })]
    }), document && /*#__PURE__*/_jsxs("div", {
      className: "document-preview",
      children: [document.type !== TaskDocumentType.Document && /*#__PURE__*/_jsx(Image, {
        fallback: "/images/fallback.jpeg",
        src: getTaskDocumentMediaSrc(task.id, document.id),
        preview: false
      }), document.type === TaskDocumentType.Document && /*#__PURE__*/_jsx(FilePdfOutlined, {
        className: "document-icon"
      })]
    })]
  });
};

var TaskCommentAddedDetails = function TaskCommentAddedDetails(_ref5) {
  var _notification$content4;

  var notification = _ref5.notification;

  var _getUserStore5 = getUserStore(),
      getUserById = _getUserStore5.getUserById;

  var _getTaskStore3 = getTaskStore(),
      getTaskById = _getTaskStore3.getTaskById;

  var author = getUserById(notification.author);
  var task = getTaskById(notification.content.task);
  var comment = useMemo(function () {
    if (!task) {
      return;
    }

    return task.comments.find(function (comment) {
      return comment.id === notification.content.comment;
    });
  }, [notification, task]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Trans, {
      i18nKey: "notifications.".concat(NotificationType.TaskCommentAdded, ".details"),
      values: {
        author: author === null || author === void 0 ? void 0 : author.name,
        task: ((_notification$content4 = notification.content.reference) !== null && _notification$content4 !== void 0 ? _notification$content4 : '?').substring(0, 50)
      },
      children: ["1", /*#__PURE__*/_jsx("em", {
        children: "1"
      }), /*#__PURE__*/_jsx("em", {
        className: "task-name",
        children: "2"
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "comment",
      children: comment === null || comment === void 0 ? void 0 : comment.text
    })]
  });
};

var TaskIncidenceAddedDetails = function TaskIncidenceAddedDetails(_ref6) {
  var _notification$content5;

  var notification = _ref6.notification;

  var _getUserStore6 = getUserStore(),
      getUserById = _getUserStore6.getUserById;

  var _getTaskStore4 = getTaskStore(),
      getTaskById = _getTaskStore4.getTaskById;

  var author = getUserById(notification.author);
  var task = getTaskById(notification.content.task);
  var incident = useMemo(function () {
    if (!task) {
      return;
    }

    return task.incidences.find(function (incidence) {
      return incidence.id === notification.content.incidence;
    });
  }, [notification, task]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Trans, {
      i18nKey: "notifications.".concat(NotificationType.TaskIncidenceAdded, ".details"),
      values: {
        author: author === null || author === void 0 ? void 0 : author.name,
        task: ((_notification$content5 = notification.content.reference) !== null && _notification$content5 !== void 0 ? _notification$content5 : '?').substring(0, 50)
      },
      children: ["1", /*#__PURE__*/_jsx("em", {
        children: "1"
      }), /*#__PURE__*/_jsx("em", {
        className: "task-name",
        children: "2"
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "incidence",
      children: incident === null || incident === void 0 ? void 0 : incident.title
    })]
  });
};

var NOTIFICATION_TYPE_DETAILS_MAP = (_NOTIFICATION_TYPE_DE = {}, _defineProperty(_NOTIFICATION_TYPE_DE, NotificationType.TaskAssigned, TaskAssignedDetails), _defineProperty(_NOTIFICATION_TYPE_DE, NotificationType.TaskReviewAssigned, TaskReviewerAssignedDetails), _defineProperty(_NOTIFICATION_TYPE_DE, NotificationType.TaskDocumentAdded, TaskDocumentAddedDetails), _defineProperty(_NOTIFICATION_TYPE_DE, NotificationType.TaskIncidenceAdded, TaskIncidenceAddedDetails), _defineProperty(_NOTIFICATION_TYPE_DE, NotificationType.TaskCommentAdded, TaskCommentAddedDetails), _NOTIFICATION_TYPE_DE); // Styles

var Container = styled(List.Item).withConfig({
  displayName: "NotificationItem__Container",
  componentId: "sc-oqlgr9-0"
})(["display:flex;min-height:20px;align-items:center;padding:12px 6px;transition:all 0.3s ease-in-out;cursor:pointer;.content{flex:1;margin-left:10px;}.title{font-weight:bold;margin-bottom:6px;margin-right:5px;}.details{color:#666;}.meta{margin-top:6px;font-size:0.8em;color:#999;}.document-preview{width:100px;height:100px;display:flex;align-items:center;justify-content:center;margin:12px 0;box-shadow:0 0 1px #666;border-radius:6px;overflow:hidden;img{border-radius:6px;object-fit:cover;}.anticon{font-size:46px;}}.comment{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;color:#999;font-size:0.9em;margin-top:12px;border-left:4px solid ", ";padding-left:12px;}.incidence{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;color:#333;font-weight:bold;font-size:0.9em;margin-top:12px;}.task-name{text-decoration:underline;}&.seen{opacity:0.4;}&.new{background-color:", ";}&.loading{.left,.content,.right{opacity:0.5;}}.ant-spin{position:absolute;left:50%;}"], Colors.geekblue[4], Colors.lightestPrimary);